export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_QUERY_DIALOG_STATE = false;
export const DEFAULT_SORT_CLAUSES = [];
export const DEFAULT_ORDER_BY_CLAUSES = [];
export const DEFAULT_WHERE_CLAUSES = [];
export const DEFAULT_PAGE_SIZES = [10, 20, 30, 40, 50, 100];
